"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExternalSelectOptionsLoad = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const types_1 = require("../../types");
const utils_1 = require("../utils");
const useExternalSelectOptionsLoad = (apiUrl, widgetId, httpClient, dataOptionsNames = ['dataOptions']) => {
    const { data, isLoading } = (0, react_query_1.useQuery)({
        queryKey: [apiUrl, widgetId],
        staleTime: Infinity,
        queryFn() {
            return httpClient(apiUrl, {
                traceId: widgetId.toString()
            });
        },
        enabled: Boolean(apiUrl),
        select: (data) => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : []; }
    });
    const columns = (0, react_1.useMemo)(() => data || [], [data]);
    const options = (0, utils_1.getAllowedColumnsByTypes)(columns !== null && columns !== void 0 ? columns : [{}], [
        types_1.DataCellTypeEnum.Double,
        types_1.DataCellTypeEnum.Text,
        types_1.DataCellTypeEnum.Integer,
        types_1.DataCellTypeEnum.Money,
        types_1.DataCellTypeEnum.DateTime,
        types_1.DataCellTypeEnum.Percent,
        types_1.DataCellTypeDAP2.Text,
        types_1.DataCellTypeDAP2.Double,
        types_1.DataCellTypeDAP2.Integer,
        types_1.DataCellTypeDAP2.Money,
        types_1.DataCellTypeDAP2.DateTime,
        types_1.DataCellTypeDAP2.Percent
    ]).map((column) => ({
        value: column.name,
        title: column.title
    }));
    const externalSelectsOptions = (0, react_1.useMemo)(() => dataOptionsNames.reduce((acc, name) => (Object.assign(Object.assign({}, acc), { [name]: options })), {}), [dataOptionsNames, options]);
    return { externalSelectsOptions, isLoading };
};
exports.useExternalSelectOptionsLoad = useExternalSelectOptionsLoad;
//# sourceMappingURL=use-external-selects-options-load.js.map